<template>
    <main class="container py-5">
        <div class="row justify-content-center">
            <div class="col-12 col-md-8 col-lg-6 text-center">
                <img width="90" src="../assets/logo.png" alt="Soca Islands" class="mb-4" />
                <h1 class="h3 fw-bold mb-3">We've moved to My Trips</h1>
                <p class="lead mb-4">
                    We've made managing your trip easier. Your booking, payments and travel details are now at
                    <strong>mytrips.socaislands.com</strong>.
                </p>
                <a :href="NEW_PORTAL" class="btn btn-dark btn-lg px-4 mb-3">Go to My Trips now</a>
                <p class="text-secondary small mb-0" aria-hidden="true">
                    Taking you there in {{ secondsLeft }} second{{ secondsLeft === 1 ? "" : "s" }}…
                </p>
                <p class="visually-hidden">You'll be taken to My Trips automatically in 15 seconds.</p>
            </div>
        </div>
    </main>
</template>

<script>
// Shown in place of every customer page of the retired app (11 Oct 2026), so
// people arriving from an old link or bookmark know why they're being moved.
const NEW_PORTAL = "https://mytrips.socaislands.com";
const WAIT_SECONDS = 15;

export default {
    name: "Moved",
    data() {
        return { NEW_PORTAL, secondsLeft: WAIT_SECONDS, timer: null };
    },
    mounted() {
        this.timer = setInterval(() => {
            this.secondsLeft -= 1;
            if (this.secondsLeft <= 0) {
                clearInterval(this.timer);
                window.location.replace(NEW_PORTAL);
            }
        }, 1000);
    },
    beforeUnmount() {
        clearInterval(this.timer);
    },
};
</script>
